import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from "react";
import { useI18N } from "../context/I18NContext";
const ErrorAlert = ({ messages, setter, noAutoClose }) => {
    const { t } = useI18N();
    const [errors, setErrors] = useState();
    useEffect(() => {
        setErrors(messages);
        if (!noAutoClose) {
            setTimeout(() => {
                setErrors(undefined);
                if (setter)
                    setter(undefined);
            }, 5000);
        }
    }, [messages]);
    return (_jsx(Collapse, { in: !!errors, children: _jsx(Alert, { sx: { my: 2 }, severity: "error", onClose: () => {
                setErrors(undefined);
                if (setter)
                    setter(undefined);
            }, children: errors === null || errors === void 0 ? void 0 : errors.map((_error, i) => (_jsx(Typography, { children: t(_error) }, i))) }) }));
};
export default ErrorAlert;
